import React from 'react';
import styled from 'styled-components';

import { Template } from '@xing-com/crate-lebenslauf-components';
import type { TemplateConfig } from '@xing-com/crate-lebenslauf-components';
import { useCoverLetterViewerBlocks } from '@xing-com/crate-lebenslauf-cover-letter-editor';
import type { TemplateCoverLetterTraditionalProps } from '@xing-com/crate-lebenslauf-xinglets/src';

// @ts-expect-error missing declaration
import { messages as messagesDE } from '../i18n/locales/de';
// @ts-expect-error missing declaration
import { messages as messagesEN } from '../i18n/locales/en';

import { Header } from './sections';

const translations = {
  EN: { messages: messagesEN },
  DE: { messages: messagesDE },
};

const CoverLetterTraditionalTheme = styled.div`
  font-family: 'Open Sans';
`;

const traditionalConfig: TemplateConfig = {
  columnSize: ['100%'],
  pageMargin: {
    top: 119,
    left: 42,
    right: 42,
    bottom: 42,
  },
};

export const CoverLetterTraditional: React.FC<
  TemplateCoverLetterTraditionalProps
> = ({ className, ...props }) => {
  const coverLetterEditor = useCoverLetterViewerBlocks();

  const unitsByColumn = React.useMemo(
    () => [[...coverLetterEditor]],
    [coverLetterEditor]
  );

  return (
    <CoverLetterTraditionalTheme className={className}>
      <Template
        translations={translations}
        unitsByColumn={unitsByColumn}
        templateConfig={traditionalConfig}
        Header={Header}
        {...props}
      />
    </CoverLetterTraditionalTheme>
  );
};
